<template>
  <div>
    <div class="between search">
      <div class="left flex1">
        <el-form label-width="82px" :mode="queryControl" label-suffix=":">
          <div class="form-box">
            <el-form-item label="年份" class="formItem">
              <el-date-picker v-model="queryControl.year" :editable="false" :clearable="false" value-format="yyyy" placeholder="请选择月份" type="year" @change="changeYear" />
            </el-form-item>
            <!-- <el-form-item label="月份">
              <el-date-picker
                v-model="queryControl.month"
                :editable="false"
                :clearable="false"
                :picker-options="pickerOptionMonth"
                placeholder="请选择月份"
                style="width: 150px;"
                type="month"
                @change="query"
              />
            </el-form-item> -->
            <el-form-item label="发起类型" prop="type" class="formItem">
              <el-select v-model="queryControl.type" placeholder="请选择" @change="query()">
                <el-option label="全部" :value="''" />
                <el-option label="平台主动发起" :value="1" />
                <el-option label="客户主动发起" :value="2" />
              </el-select>
            </el-form-item>
            <el-form-item label="发起时间" class="formItem">
              <el-date-picker
                v-model="queryControl.query_date"
                type="daterange"
                range-separator="~"
                start-placeholder="开始日期"
                :clearable="true"
                end-placeholder="结束日期"
                :editable="false"
                :value-format="'yyyy-MM-dd'"
                unlink-panels
                :picker-options="pickerOptions"
                @change="query"
              />
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div>
        <el-button type="primary" @click="query">查询</el-button>
        <el-button @click="resetForm">重置</el-button>
      </div>
    </div>
    <div class="total_box mb22">
      <span>对账中总金额：<span class="active_color">￥{{ $formatCurrency(in_all_price) || '0.00' }}</span></span>
    </div>
    <zf-table
      :columns="column"
      :data-source="tableData"
      :pagination="false"
    >
      <!-- 月份 -->
      <template
        slot="month"
        slot-scope="{ row }"
      >
        <span>{{ row.month }}</span>
      </template>
      <!-- 消耗金额 -->
      <template
        slot="work_price"
        slot-scope="{ row }"
      >
        ￥{{ $formatCurrency(row.work_price) }}
      </template>
      <!-- 支付宝金额 -->
      <template
        slot="zfb_price"
        slot-scope="{ row }"
      >
        ￥{{ $formatCurrency(row.zfb_price) }}
      </template>
      <!-- 微信金额 -->
      <template
        slot="wx_price"
        slot-scope="{ row }"
      >
        ￥{{ $formatCurrency(row.wx_price) }}
      </template>
      <!-- 服务费率 -->
      <template
        slot="rate"
        slot-scope="{ row }"
      >
        {{ row.rate }}%
      </template>
      <!-- 服务费 -->
      <template
        slot="service_price"
        slot-scope="{ row }"
      >
        ￥{{ $formatCurrency(row.service_price) }}
      </template>
      <!-- 对账金额 -->
      <template
        slot="rcon_price"
        slot-scope="{ row }"
      >
        ￥{{ $formatCurrency(row.rcon_price) }}
      </template>
      <!-- 对账周期 -->
      <template
        slot="start_day"
        slot-scope="{ row }"
      >
        {{ row.start_day }} ~ {{ row.end_day }}
      </template>
      <!-- 发起时间 -->
      <template
        slot="send_time"
        slot-scope="{ row }"
      >
        {{ row.send_time }}
      </template>
      <!-- 发起类型 -->
      <template
        slot="type"
        slot-scope="{ row }"
      >
        {{ row.type == 1 ? '平台发起' : '客户发起' }}
      </template>
      <!-- 操作 -->
      <template
        slot="action"
        slot-scope="{ row }"
      >
        <a v-if="row.type == 1 && powerReg('c71d6e947d1bef6d41dbd315b13b67ae')" class="active_color" @click="sign(row)">签署对账单</a>
        <a v-if="row.type == 2 && powerReg('cb2b5dff68edc737813fc7e8b910c0b7')" class="active_color" @click="cancel(row)">撤销</a>
        <el-divider v-if="row.type == 1 && powerReg('96c58f117b2a3f5c587c004b7cf62728') && powerReg('c71d6e947d1bef6d41dbd315b13b67ae')" direction="vertical" />
        <a v-if="row.type == 1 && powerReg('96c58f117b2a3f5c587c004b7cf62728')" class="del" @click="refuse(row)">拒绝</a>
      </template>
    </zf-table>
    <el-dialog title="拒绝" :visible.sync="refuseFormVisible" center width="400px" :before-close="beforeClose">
      <div>是否拒绝此对账单？</div>
      <el-form ref="refusForm" :model="refusForm" :rules="refuseRules">
        <el-form-item label="理由:" prop="refuse">
          <el-input v-model="refusForm.refuse" type="textarea" :rows="3" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="hide">取 消</el-button>
        <el-button type="primary" @click="submitRefuse">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="提醒" :visible.sync="uploadVisible" center width="400px" append-to-body>
      <div class="mb15 del">首次签署请上传"一般纳税人文件"。</div>
      <el-upload :class="{disUoloadSty: noneBtnImg}" action="#" :limit="1" :multiple="false" :auto-upload="true" :on-remove="handleRemove" :on-change="uploadChange" :before-upload="beforeUploadFile" :file-list="fileList" :http-request="uploadFile">
        <el-button size="small" type="primary"><i class="el-icon-upload2" />上传文件</el-button>
        <div slot="tip" class="el-upload__tip fs12 c9" style="line-height: 20px;">支持扩展名：.doc .docx .pdf .jpg .png .xls .xlsx，文件大小20MB以内</div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="uploadVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitFn">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="开票信息" width="800px" :visible.sync="infoVisible" center :before-close="(done) => {checked = false; done()}">
      <div v-if="!info.invoice_title" class="flex_center">暂无开票信息</div>
      <div v-else class="flex">
        <el-form :mode="info" label-width="120px" class="noMB flex1">
          <div class="bold mb22">发票信息<span class="active_color ml20 pointer" @click="$router.push('/invoice/bill_info')">去编辑</span></div>
          <el-form-item label="发票抬头:">{{ info.invoice_title }}</el-form-item>
          <el-form-item label="纳税人识别号:">{{ info.invoice_code }}</el-form-item>
          <el-form-item label="开户行及账号:">{{ info.bank }}</el-form-item>
          <!-- <el-form-item label="开户账号：">{{info.bank_card}}</el-form-item> -->
          <el-form-item label="地址、电话:">{{ info.company_address }}</el-form-item>
          <el-form-item label="开票内容:">{{ info.invoice_content }}</el-form-item>
        </el-form>
        <el-form :mode="info" label-width="120px" class="noMB flex1">
          <div class="bold mb22">收票信息<span class="active_color ml20 pointer" @click="$router.push('/invoice/bill_info')">去编辑</span></div>
          <el-form-item label="收件人:">{{ info.receive_person }}</el-form-item>
          <el-form-item label="手机号:">{{ info.receive_phone }}</el-form-item>
          <el-form-item label="收件地址:">{{ info.detail }}</el-form-item>
          <!-- <el-form-item label="详细地址：">{{info.address}}</el-form-item> -->
          <!-- <el-form-item label="邮编：">{{info.zip_code}}</el-form-item> -->
        </el-form>
      </div>
      <div v-if="info.invoice_title" slot="footer" class="dialog-footer">
        <el-checkbox v-model="checked">请确认开票信息无误</el-checkbox>
        <el-button class="ml30" type="primary" @click="infoSure">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import column from '../columns/accountCheckUnderway'
import dayJs from 'dayjs'
import ZfTable from '@/components/ZfTable/CoreTable'
import { inInvoice, signInvoice, revokeInvoice, refuseInvoice, getInvioceinfo, uploadTaxpayer } from '@/api/invoice'
import { uploadNewFile } from '@/api/common'
export default {
  name: 'AccountCheckUnderway',
  components: {
    ZfTable
  },
  data() {
    const that = this
    return {
      column,
      queryControl: {
        // month: dayJs().format('YYYY-MM'),
        month: '',
        type: '',
        query_date: [],
        year: dayJs().format('YYYY')
      },
      tableData: [],
      pickerOptionMonth: {
        disabledDate(time) {
          const curYearTime = new Date(`${that.queryControl.year}`).getTime()
          const nextYearTime = new Date(`${+that.queryControl.year + 1}`).getTime()
          const curTime = time.getTime()
          if (curYearTime <= Date.now() && Date.now() < nextYearTime) {
            return curTime < curYearTime || curTime > Date.now()
          } else {
            return curTime < curYearTime || curTime > nextYearTime - 1 * 24 * 60 * 60 * 1000
          }
        }
      },
      recon_id: '',
      in_all_price: '',
      refuseFormVisible: false,
      refuseRules: {
        refuse: [
          { required: true, message: '请输入拒绝理由', trigger: 'blur' }
        ]
      },
      refusForm: {
        refuse: ''
      },
      settleVisible: false,
      fileList: [],
      uploadVisible: false,
      noneBtnImg: false,
      infoVisible: false,
      info: {},
      row: {},
      checked: false
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    async query() {
      const res = await inInvoice({
        year: this.queryControl.year,
        send_time_start: this.queryControl.query_date && this.queryControl.query_date.length ? this.queryControl.query_date[0] : '',
        send_time_end: this.queryControl.query_date && this.queryControl.query_date.length ? this.queryControl.query_date[1] : '',
        // month: this.$dayFormat(this.queryControl.month, 2),
        type: this.queryControl.type
      })
      if (res.code === 200) {
        this.tableData = res.data.list
        this.in_all_price = res.data.in_all_price
      }
    },
    changeYear(val) {
      // this.queryControl.month = val
      this.query()
    },
    resetForm() {
      this.queryControl = {
        // month: dayJs().format('YYYY-MM'),
        type: '',
        query_date: [],
        year: dayJs().format('YYYY')
      }
      this.query()
    },
    async refuse(row) {
      this.refuseFormVisible = true
      this.recon_id = row.recon_id
    },
    submitRefuse() {
      this.$refs.refusForm.validate(async(valid) => {
        if (valid) {
          // 拒绝
          refuseInvoice({
            recon_id: this.recon_id,
            refuse: this.refusForm.refuse
          }).then(res => {
            if (res.code === 200) {
              this.$message.success('拒绝成功')
              this.refuseFormVisible = false
              this.query()
            }
          })
        }
      })
    },
    beforeClose(done) {
      this.$refs.refusForm.resetFields()
      done()
    },
    hide() {
      this.$refs.refusForm.resetFields()
      this.refuseFormVisible = false
    },
    async cancel(row) {
      this.$confirm('确定撤销吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 撤销
        revokeInvoice({
          recon_id: row.recon_id
        }).then(data => {
          if (data.code === 200) {
            this.$message.success('撤销成功')
            this.query()
          }
        })
      }).catch(() => {
        this.$message.info('已取消撤销')
      }
      )
    },
    async sign(row) {
      const data = await getInvioceinfo({
        recon_id: row.recon_id
      })
      if (data.code === 200) {
        this.row = row
        this.infoVisible = true
        this.info = {
          ...data.data.company_invoice,
          ...data.data.invoice_receive_address
        }
      }
    },
    async infoSure() {
      if (!this.checked) {
        this.$message.error('请勾选确认开票信息无误!')
        return
      }
      signInvoice({
        recon_id: this.row.recon_id
      }).then(data => {
        if (data) {
          if (data.code && data.code === 2001) {
            this.uploadVisible = true
          } else if (data.code === 200) {
            this.settleVisible = false
            this.infoVisible = false
            this.$message.success('签署成功')
            this.query()
          }
        }
      })
    },
    handleRemove(file, fileList) {
      this.noneBtnImg = fileList.length >= 1
      this.fileList = []
      this.file_code = ''
    },
    uploadChange(file, fileList) {
      this.noneBtnImg = fileList.length >= 1
    },
    beforeUploadFile(file) {
      const type = /^(.doc|.docx|.pdf|.jpg|.png|.xls|.xlsx)$/.test(file.name.slice(file.name.lastIndexOf('.')))
      const size = file.size / 1024 / 1024 < 20
      if (!type) {
        this.$message('文件格式错误,请重新选择')
      }
      if (!size) {
        this.$message('文件大小不可超过20MB')
      }
      return type && size
    },
    uploadFile(file) {
      const params = new FormData()
      params.append('file', file.file)
      this.noneBtnImg = true
      uploadNewFile(params).then(data => {
        if (data.code === 200) {
          this.fileList = [{ name: data.data.filename, url: data.data.fullpath, code: data.data.code }]
          this.file_code = data.data.code
        }
      })
    },
    async submitFn() {
      const data = await uploadTaxpayer({
        taxpayer: this.file_code
      })
      if (data.code === 200) {
        this.uploadVisible = false
        this.$message.success('上传成功, 请重新点击"签署对账单"')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ml30{
  margin-left: 30px;
}
</style>

